var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6575 12.5176C23.6575 6.44466 18.7304 1.51758 12.6575 1.51758C6.58455 1.51758 1.65747 6.44466 1.65747 12.5176C1.65747 18.5905 6.58455 23.5176 12.6575 23.5176C18.7304 23.5176 23.6575 18.5905 23.6575 12.5176Z",
    stroke: "#C2CFE0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6575 7.93408C13.6575 7.3818 13.2098 6.93408 12.6575 6.93408C12.1052 6.93408 11.6575 7.3818 11.6575 7.93408V11.5175H8.07422C7.52193 11.5175 7.07422 11.9652 7.07422 12.5175C7.07422 13.0697 7.52193 13.5175 8.07422 13.5175H11.6575V17.1007C11.6575 17.653 12.1052 18.1007 12.6575 18.1007C13.2098 18.1007 13.6575 17.653 13.6575 17.1007V13.5175H17.2409C17.7932 13.5175 18.2409 13.0697 18.2409 12.5175C18.2409 11.9652 17.7932 11.5175 17.2409 11.5175H13.6575V7.93408Z",
    fill: "#C2CFE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.6b10bcfd4e28baaccf824bb8e2865bf9.svg";
export { ForwardRef as ReactComponent };